import Api from './Api';
import { Intent } from '../../model/intent/types';

class IntentsApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '/Intents', headers);
  }

  get = (botId: string) => this.instance.get(`/${botId}`);

  create = (botId: string, intent: Intent) => this.instance.post(`/${botId}`, intent);

  update = (botId: string, intent: Intent) => this.instance.put(`/${botId}/${intent.id!}`, intent);

  delete = (botId: string, intentId: string) => this.instance.delete(`/${botId}/${intentId}`);

  parse = (botId: string, text: string) => this.instance.post(`/parse/${botId}/?text=${text}`);
}

export default IntentsApi;
